(function () {
  'use strict';

  var TIERS = [
    { min: 4, pct: 20, code: 'AXIO20' },
    { min: 3, pct: 15, code: 'AXIO15' },
    { min: 2, pct: 10, code: 'AXIO10' },
  ];

  function getTier(qty) {
    for (var i = 0; i < TIERS.length; i++) {
      if (qty >= TIERS[i].min) return TIERS[i];
    }
    return null;
  }

  function applyToForms(tier) {
    var forms = document.querySelectorAll('#CartDrawer-Form, #cart, form[action="/cart"]');
    for (var i = 0; i < forms.length; i++) {
      var form = forms[i];
      var inp = form.querySelector('input[data-vd]');
      if (!inp) {
        inp = document.createElement('input');
        inp.type = 'hidden';
        inp.name = 'discount';
        inp.setAttribute('data-vd', '');
        form.appendChild(inp);
      }
      inp.value = tier ? tier.code : '';
    }
    var links = document.querySelectorAll('a[href="/checkout"], a[href^="/checkout?"]');
    for (var j = 0; j < links.length; j++) {
      links[j].href = tier ? '/checkout?discount=' + tier.code : '/checkout';
    }
  }

  function refresh() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        applyToForms(getTier(cart.item_count));
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('cart:updated', refresh);
  document.addEventListener('cart:open', refresh);
})();
